<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />

    <h3 class="lszjkdsdgjkh">Organigrama de Ministerio</h3>

    <div class="container">
      <Help :title="title" :text="text" :uno="uno" :dos="dos" />
    </div>
    <div class="hola">
      <Main />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./main/Main";
import Help from "../../../components/tools/Modal.vue";

import { mapState } from "vuex";

export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
    Help,
  },
  data() {
    return {
      breadCrumbData: null,
      data: "@/assets/prueba/o.png",
      title: "Organigrama de Ministerio",
      text:
        "Para completar el servicio por favor seguir las siguientes instrucciones",
      uno: "Se permite formato PNG, SVG, y JPG",
      dos: "Tamaño de la imagen max: 2mb",
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Organigrama de Ministerio",
          routeName: "oministerio",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerContenido: async function() {
      this.data = "@/assets/prueba/o.png";
      console.log("petición");
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerContenido();
  },
};
</script>

<style scoped>
.lszjkdsdgjkh {
  text-align: center;
  font-weight: bold;
}

.container {
  margin-bottom: 20px;
}


</style>
